// 与 server/app/tools/index.js base62Encode 保持一致（0-9A-Za-z，62 字符）
// 用于拼店铺/账号短链：https://yxdj.tech/_{base62(shopId)}
const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

// isFromHead 混编基准：与 server SHOP_SHORT_URL_HEAD_OFFSET 一致。
// 勾选总公司渠道时短链 = base62Encode(shopId + OFFSET)，解码端 v>=OFFSET 判定 isFromHead。
export const OFFSET = 1000000000000;   // 1e12

export function base62Encode(num) {
  num = Number(num);
  if (!isFinite(num) || num < 0) return '';

  if (num === 0) return '0';

  let result = '';
  while (num > 0) {
    result = CHARS[num % 62] + result;
    num = Math.floor(num / 62);
  }

  return result;
}
